// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/welcome","name":"대시보드","icon":"dashboard","parentId":"ant-design-pro-layout","id":"3"},"4":{"name":"사용자 관리","icon":"user","path":"/user-list","parentId":"ant-design-pro-layout","id":"4"},"5":{"name":"컨텐츠 신고 관리","icon":"user","path":"/content-report-list","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/","redirect":"/welcome","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"*","layout":false,"id":"7"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__analysis__index" */'@/pages/analysis/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__user-list__index" */'@/pages/user-list/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__content-report-list__index" */'@/pages/content-report-list/index.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'C:/Users/kyyyy/desktop/lounge-admin-client/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
